// extracted by mini-css-extract-plugin
export default {"tableColor":"TableCeil_tableColor__R5Mo9","tablePickColor":"TableCeil_tablePickColor__s7for","tableBlockColor":"TableCeil_tableBlockColor__2Rwen","last":"TableCeil_last__ZfqSe"};